export const CURRENCIES = {
  USD: {
    code: "USD",
    symbol: "$",
    name: "US Dollar",
  },
  NGN: {
    code: "NGN",
    symbol: "₦",
    name: "Nigerian Naira",
  },
  EUR: {
    code: "EUR",
    symbol: "€",
    name: "Euro",
  },
  GBP: {
    code: "GBP",
    symbol: "£",
    name: "British Pound",
  },
  CAD: {
    code: "CAD",
    symbol: "C$",
    name: "Canadian Dollar",
  },
  AUD: {
    code: "AUD",
    symbol: "A$",
    name: "Australian Dollar",
  },
  JPY: {
    code: "JPY",
    symbol: "¥",
    name: "Japanese Yen",
  },
  CHF: {
    code: "CHF",
    symbol: "CHF",
    name: "Swiss Franc",
  },
  CNY: {
    code: "CNY",
    symbol: "¥",
    name: "Chinese Yuan",
  },
  INR: {
    code: "INR",
    symbol: "₹",
    name: "Indian Rupee",
  },
};

/**
 * Get display symbol from an ISO currency code (e.g. "NGN" -> "₦").
 * Falls back to the code itself if not found.
 */
export const getCurrencySymbolFromCode = (currencyCode) => {
  if (!currencyCode) return "$";
  const entry = CURRENCIES[currencyCode.toUpperCase()];
  return entry ? entry.symbol : currencyCode;
};

export const CURRENCY_OPTIONS = Object.entries(CURRENCIES).map(
  ([, currency]) => ({
    value: currency.code,
    label: `${currency.symbol} ${currency.name} (${currency.code})`,
  })
);

/**
 * Get currency code based on country ID
 * Maps countries to their respective currencies
 * @param {string|number} countryId - The country ID
 * @returns {string} Currency code (CNY, EUR, INR, GBP, CAD, or USD as default)
 */
export const getCurrencyFromCountry = (countryId) => {
  const id = String(countryId);

  // Currency mapping by country ID
  const currencyMap = {
    // Nigerian Naira
    160: "NGN", // Nigeria

    // Chinese Yuan
    44: "CNY", // China

    // Euro - European countries in the Eurozone
    14: "EUR", // Austria
    21: "EUR", // Belgium
    56: "EUR", // Cyprus
    68: "EUR", // Estonia
    74: "EUR", // Finland
    75: "EUR", // France
    82: "EUR", // Germany
    85: "EUR", // Greece
    105: "EUR", // Ireland
    107: "EUR", // Italy
    120: "EUR", // Latvia
    126: "EUR", // Lithuania
    127: "EUR", // Luxembourg
    135: "EUR", // Malta
    155: "EUR", // Netherlands
    176: "EUR", // Portugal
    197: "EUR", // Slovakia
    198: "EUR", // Slovenia
    205: "EUR", // Spain

    // Indian Rupee
    101: "INR", // India

    // British Pound
    230: "GBP", // United Kingdom

    // Canadian Dollar
    38: "CAD", // Canada

    // US Dollar
    231: "USD", // United States
  };

  return currencyMap[id] || "USD"; // Default to USD
};
